/**
 * GroupsTableHead
 */
import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
import TableHeadTableCell from '../../../../../../../../components/TableHeadTableCell';

export default class GroupsTableHead extends React.PureComponent<*> {
    render() {
        return (
            <Table.Header
                // HACK inline styles
                style={{
                    fontSize: 14
                }}
            >
                <Table.Row>
                    <TableHeadTableCell
                        label="Name"
                        value="name"
                        defaultSort="name"
                    />
                    <Table.HeaderCell style={{ maxWidth: '250px' }}>
                        People
                    </Table.HeaderCell>
                    <Table.HeaderCell>Sectors</Table.HeaderCell>
                    <Table.HeaderCell />
                </Table.Row>
            </Table.Header>
        );
    }
}
